// extracted by mini-css-extract-plugin
export default {"cart":"CartImage_cart__LsB6O","sidecart":"CartImage_sidecart__2iIBb","maincart":"CartImage_maincart__dLU2-"};